<template>
  <div>
    <div class="">
      <h2>{{ $t("transfer.library-text") }}</h2>
    </div>

    <right-panel class="float-right" id="sidebar-transfer-records" width="800px" :icon="'mdi mdi-book-open'" :text="$t('transfer.records')" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form :hide-library="true" />
      </div>
    </right-panel>

    <table style="width: 100%;">
      <tr>
        <th>
          <filter-select
            id="sectorFilter"
            ref="sectorFilter"
            :selected="form.sector"
            :placeholder="$t('sector.text')"
            :multiple="false"
            @filter="onSectorSearch"
            @changed="onSectorSelect"
            :disabled="isAtLeastOneItemSelected"
          />
        </th>
        <th></th>
        <th>
          <filter-select
            id="levelFilter"
            ref="levelFilter"
            :placeholder="$t('common.select-level')"
            :multiple="false"
            @filter="onLevelSearch"
            :selected="form.level"
            @changed="onLevelSelect"
            track="definition"
            :disabled="isAtLeastOneItemSelected"
          />
        </th>
        <th></th>
        <th>
          <date-picker v-model="form.rangeDate" range :placeholder="$t('common.date')" @change="setTimeValue" :disabled="isAtLeastOneItemSelected" :lang="lang"> </date-picker>
        </th>
        <th></th>
        <th style=" width: 4% ;padding: 5px;" class="text-center">
          <b-button @click="transferScan()" variant="dark" size="m" :disabled="!(form.sector && form.level && form.rangeDate[0] > 0)">
            {{ $t("common.scan") }}
          </b-button>
        </th>
        <th></th>
      </tr>
    </table>

    <!--    Logic için table  -->

    <div class="bg-white">
      <table class="table table-bordered table-striped">
        <thead class="bg-secondary text-white">
          <tr>
            <th style="width: 100px">
              <b-dropdown split :text="$t('common.select-all')" class="btn-block" variant="secondary" size="sm" @click="selectAllItems">
                <template #button-content>
                  <b> {{ form.selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
                </template>

                <b-dropdown-item href="#" @click="transferRecord()" :disabled="!isAtLeastOneItemSelected">
                  <i class="bx bx-transfer" v-b-tooltip.hover :title="$t('common.transfer')"></i> {{ $t("common.transfer") }} ({{ form.selectedItems.length }})
                </b-dropdown-item>
              </b-dropdown>
            </th>
            <sortable-table-head field="name" :text="$t('common.name')" :request="request" />
            <th>{{ $t("common.type") }}</th>
            <th>{{ $t("common.created-by") }}</th>
            <th scope="col" style="width: 15%">
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-white">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filterEnabled">
            <th></th>
            <th><input class="form-control " v-model="nameFilter" /></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <template v-if="paginationScanItems">
            <tr v-for="item in paginationScanItems.docs" :key="item._id">
              <td>
                <div class="text-center">
                  <b-form-checkbox v-model="form.selectedItems" :value="item" class="custom-checkbox-primary mb-3 " checked></b-form-checkbox>
                </div>
              </td>
              <td>{{ item.name | translate }}</td>
              <td>
                <span v-if="item.scope.value == 'workspace' && item.scope.workspace" v-b-tooltip.hover :title="item.scope.workspace.owner.name + '/' + item.scope.workspace.name">
                  <i class="text-muted mdi mdi-hexagon-multiple-outline"></i>
                  {{ item.scope.workspace.owner.name + "/" + item.scope.workspace.name }}
                </span>
                <span v-else v-b-tooltip.hover :title="$t('library.belonging-to-the-system')">
                  <i class="text-muted mdi mdi-database"></i>
                  {{ item.scope.value }}
                </span>
              </td>
              <td>{{ item.scope.createdBy.name }}</td>
              <td></td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <content-loading v-if="loading" />

    <empty v-if="!loading && (!paginationScanItems || paginationScanItems.docs.length == 0)">
      <h5 class="text-center" id="myText">
        {{ $t("common.not-found") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->
    <div v-if="paginationScanItems" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="paginationScanItems.totalDocs" :per-page="paginationScanItems.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/tr";
import Level from "./level.json";
import Form from "./management-transfer-library-form";

export default {
  components: { DatePicker, Form },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { "scope.workspace": "asc" } },
        query: { "scope.value": { value: "workspace", isObject: true } },
      },
      form: { sector: undefined, level: undefined, rangeDate: [], selectedItems: [] },
      nameFilter: undefined,
      scopeFilter: undefined,
      filterEnabled: false,
      lang: "tr",
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.init());
      },
    },

    nameFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },
  },
  computed: {
    loading() {
      return this.$store.getters[`managementTransfer/isLoading`];
    },
    paginationScanItems() {
      return this.$store.getters[`managementTransfer/paginationScanItems`];
    },
    isAtLeastOneItemSelected() {
      return this.form.selectedItems.length > 0;
    },
  },
  mounted() {},
  methods: {
    init() {
      if (this.form.sector && this.form.level) {
        const startTime = new Date(this.form.rangeDate[0]).getTime();
        const endTime = new Date(this.form.rangeDate[1]).getTime();
        this.$store.dispatch(`managementTransfer/transferScan`, { ...this.form, rangeDate: [startTime, endTime], pagination: { ...this.request } });
        this.form.selectedItems = [];
      }
    },

    async onSectorSearch(value, callback) {
      const response = await this.$store.dispatch(`managementSector/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },

    onSectorSelect(sector) {
      this.form = { ...this.form, sector };
    },
    async onLevelSearch(value, callback) {
      const response = Level;
      callback(response);
    },
    onLevelSelect(item) {
      this.form = { ...this.form, level: item };
    },

    selectAllItems() {
      if (this.form.selectedItems.length > 0) {
        this.form.selectedItems = [];
      } else {
        this.form.selectedItems = this.paginationScanItems.docs.slice();
      }
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
    setTimeValue(item) {
      this.form.rangeDate = item;
    },
    rightPanelClosed() {
      this.$store.commit(`managementTransfer/editedEntity`, null);
    },

    async transferScan() {
      try {
        const startTime = new Date(this.form.rangeDate[0]).getTime();
        const endTime = new Date(this.form.rangeDate[1]).getTime();
        await this.$store.dispatch("managementTransfer/transferScan", {
          ...this.form,
          rangeDate: [startTime, endTime],
          pagination: { ...this.request },
        });
        this.$toast.success(this.$t("common.success"));
        this.form.selectedItems = [];
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async transferRecord() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const startTime = new Date(this.form.rangeDate[0]).getTime();
        const endTime = new Date(this.form.rangeDate[1]).getTime();
        await this.$store.dispatch("managementTransfer/transfer", {
          ...this.form,
          transferPiece: this.form.selectedItems.length,
          rangeDate: [startTime, endTime],
        });
        this.$store.dispatch(`managementTransfer/paginate`, this.request);
        this.$toast.success(this.$t("common.success"));
        this.init();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
